/**
 * Seriennummern je Bestands-Position (#182).
 *
 * Assets (Geräte, Typ `single`) tragen die Seriennummer und zeigen über
 * `current_position_id` auf ihren Lagerplatz. Der Positions-Picker sucht
 * darin; ausgeliehene oder abgegangene Geräte ohne Position fallen weg.
 */
export function serialsByPositionFrom(assets) {
    const map = {};
    for (const asset of assets || []) {
        const positionId = asset.current_position_id;
        const serial = (asset.serial_number || "").trim();
        if (!positionId || !serial) continue;
        (map[positionId] ||= []).push(serial);
    }
    return map;
}
